import cn from "@/v2-ui/utils/utils.cn"
import DropdownMenu from "@/v2-ui/dropdownMenu"
import {
  TooltipButton,
  type TooltipButtonProps,
} from "@/v2-backoffice-client/components/button"

export type ActionMenuTriggerProps = TooltipButtonProps

// Most triggers are the bare three-dots button, which says nothing about
// what it opens and offers a screen reader nothing at all — hence the
// fallback. A menu that does something more specific than "the actions for
// this row" should pass its own `content`.
const DEFAULT_CONTENT = "Actions"

function ActionMenuTrigger(props: ActionMenuTriggerProps) {
  const {
    className,
    children,
    onClick,
    content = DEFAULT_CONTENT,
    label,
    ...buttonProps
  } = props

  return (
    <DropdownMenu.Trigger asChild>
      <TooltipButton
        className={cn("action-menu-trigger", className)}
        variant="ghost"
        size="tiny"
        iconSrc="menu-dots-vertical"
        iconSize={12}
        content={content}
        label={label ?? (typeof content === "string" ? content : undefined)}
        onClick={(e) => {
          e.stopPropagation()
          onClick?.(e)
        }}
        {...buttonProps}
      >
        {children}
      </TooltipButton>
    </DropdownMenu.Trigger>
  )
}

export default ActionMenuTrigger
